import { render, staticRenderFns } from "./SupervisorDashboard.vue?vue&type=template&id=90fbbf8e&scoped=true&"
import script from "./SupervisorDashboard.vue?vue&type=script&lang=js&"
export * from "./SupervisorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorDashboard.vue?vue&type=style&index=0&id=90fbbf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fbbf8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
